<template>
  <div>
    <h4 class="header" v-html="data.question" />
    <form class="ui form">
      <textarea v-model="answer" />
    </form>
    <p class="disclaimer"><i>*Interactions are designed to help learning retention only. Interaction data is not stored for reporting.</i></p>
  </div>
</template>

<script>
import ScormService from '@/services/scorm/scorm.js';

export default {
  name: 'ThoughtQuestion',
  props: ['id', 'type', 'data', 'standard'],
  data() {
    return {
      answer: '',
      submitted: false,
    };
  },
  methods: {
    checkIsValid() {
      this.$emit('valid', this.answer.length > 0);
    },
    saveSCORMInteraction() {
      const scormData = {
        id: this.id,
        type: this.type,
        isCorrect: 'n/a',
        answer: this.answer,
        description: this.data.question,
      };
      ScormService.saveSCORMInteraction(scormData);
    },
    submit() {
      this.submitted = true;
      if (this.standard === 'SCORM_2004') {
        this.saveSCORMInteraction();
      }
      this.$emit('valid', false);
      this.$emit('close');
    },
  },
  watch: {
    answer() {
      this.checkIsValid();
    },
  },
};
</script>
